import { EntityReferenceModel } from "../../clients/KompasApi";

export class EntityReferenceModelGroup<T extends EntityReferenceModel>
  implements EntityReferenceModel
{
  constructor(public id: number, public name: string, public children: Array<T | EntityReferenceModelGroup<T>> = []) { }
}
